module.exports = __webpack_public_path__ + "static/img/home_zjgx_pic1.fe4e976.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_zjgx_pic1.png
// module id = iPBx
// module chunks = 0